import { Badge } from '@/components/ui/badge';
import { STATUS_MAP } from '@/constants';

const StatusBadge = ({ status }) => {
  const statusItem = STATUS_MAP[status];
  const StatusIcon = statusItem?.icon;

  if (!statusItem) return '-';

  return (
    <Badge className="gap-1" variant={statusItem.variant}>
      {StatusIcon && <StatusIcon className="h-5 w-5" />}
      {statusItem.text}
    </Badge>
  );
};

export default StatusBadge;
